import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  NbAccordionModule,
  NbButtonModule,
  NbIconModule,
  NbInputModule,
  NbOptionModule,
  NbSelectModule,
  NbTooltipModule
} from '@nebular/theme';
import { SurveyActionsComponent } from '../survey-actions/survey-actions.component';

@Component({
  selector: 'app-survey-answers',
  templateUrl: './survey-answers.component.html',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NbAccordionModule,
    NbButtonModule,
    NbIconModule,
    NbInputModule,
    NbSelectModule,
    NbOptionModule,
    NbTooltipModule,
    SurveyActionsComponent
  ],
  standalone: true
})
export class SurveyAnswersComponent {
  @Input() group!: FormGroup;
  @Input() qi!: number;
  @Input() ai!: number;

  @Output() addAction = new EventEmitter<{ ai: number }>();
  @Output() removeAnswer = new EventEmitter<{ ai: number }>();
  @Output() removeAction = new EventEmitter<{ ai: number; aci: number }>();

  public answerTypes = ['text', 'rating'];

  actions(): FormArray<FormGroup> {
    return this.group.get('actions') as FormArray<FormGroup>;
  }
}
